import {sendRequest, replaceModal} from "./components/replaceModal.js";
import {jsAjaxButtonHandler} from "./components/jsAjaxButtonHandler.js";

let Register = {
    modalName: "loyalty-register",
    /**
     * Флаг, находимся ли на странице заказа. Кроме заказа, можем быть в ЛК.
     *
     * @param {Boolean}
     */
    isOrderPage: true,
    /**
     * Метка времени (в миллисекундах), когда в последний раз отображали окно подключения к программе лояльности.
     * Нужно, чтобы замерять время между показами окна: не показывать окно слишком часто (чаще, чем раз в 5 минут).
     */
    showFormLastDate: null,
    init: function () {
        "use strict";

        const lpData = window.obMindbox.register.getLoyaltyProgramData();
        if ("Y" === lpData.isNeedMindboxUserCheck) {
            // Пытаемся получить идентификатор пользователя в Mindbox,
            // если пользователь с таким телефоном или email там есть
            window.obMindbox.personal.getMindboxUserId()
                .then(function (mindboxUserId) {
                    if (mindboxUserId) {
                        return mindboxUserId;
                    } else {
                        // Такого пользователя не нашлось в Mindbox: надо его зарегистрировать там
                        return Register.sendRegister();
                    }
                })
                .catch(function (reason) {
                    window.console.log(reason);
                })
                .then(function (mindboxUserId) {
                    if (mindboxUserId && "Y" === lpData.isNeedMindboxLpCheck && Register.isReadyToShowFormAgain()) {
                        // Пора пользователю предложить зарегистрироваться в программе лояльности
                        Register.checkLoyaltyProgram();
                    }
                })
                .catch(function (reason) {
                    window.console.log(reason);
                });
        } else if ("Y" === lpData.isNeedMindboxLpCheck) {
            window.obMindbox.personal.getMindboxUserId()
                .then(function (mindboxUserId) {
                    if (mindboxUserId && Register.isReadyToShowFormAgain()) {
                        // Предлагаем пользователю зарегистрироваться в программе лояльности
                        Register.checkLoyaltyProgram();
                    }
                })
                .catch(function (reason) {
                    window.console.log(reason);
                });
        }

        // Обработка переключателя флага "Согласен на участие в программе лояльности"
        Register.initSwitchLoyaltyCheckbox();

        // Обработка смены телефона пользователя
        Register.initChangePhone();
    },
    /**
     * Функция проверяет, прошло ли достаточно времени с последнего показа окна подключения к программе лояльности.
     * Если прошло достаточно времени, то обновляем метку времени и возвращаем ИСТИНУ.
     * Дам передышку в 5 минут.
     */
    isReadyToShowFormAgain: function () {
        "use strict";

        const dateTimeNow = new Date();

        if (
            null === Register.showFormLastDate
            || (dateTimeNow.getTime() - Register.showFormLastDate.getTime()) > 300000
        ) {
            Register.showFormLastDate = dateTimeNow;
            return true;
        }

        return false;
    },
    /**
     * Инициализация изменения телефона пользователя
     */
    initChangePhone: function () {
        "use strict";

        const phoneInputs = document.querySelectorAll(".js-user-phone");
        if (phoneInputs) {
            Array.prototype.forEach.call(phoneInputs, function (phoneInput) {
                phoneInput.addEventListener("change", Register.changePhoneHandler);
            });
        }
    },
    /**
     * Функция добавляет обработчик события клика по кнопке переотправки СМС
     * с подтверждением телефона
     */
    initResendSms: function () {
        "use strict";

        const resendButtons = document.querySelectorAll(".js-mindbox-resend-sms");
        if (resendButtons) {
            Array.prototype.forEach.call(resendButtons, function (resendButton) {
                resendButton.addEventListener("click", Register.clickResendSmsHandler);
            });
        }
    },
    /**
     * Обработчик клика по кнопке переотправки СМС
     *
     * @param {Object} event
     */
    clickResendSmsHandler: function (event) {
        "use strict";

        if (!!event) {
            window.obMindbox.addLoadingToBtn(event.target);
            const mindboxUserId = window.obMindbox.personal.mindboxUserId;
            const phones = document.querySelectorAll(".js-user-phone-for-confirmation");
            let phone = "";
            if (phones) {
                phone = phones[0].value;
            }
            Register.resendSms(mindboxUserId, phone)
                .then(function (jsonResponse) {
                    if (!jsonResponse.success && jsonResponse.hasOwnProperty("arErrors") && jsonResponse.arErrors.length) {
                        Register.showMessageModalForm(
                            document.getElementById(Register.modalName),
                            [],
                            [],
                            jsonResponse.arErrors
                        );
                    }
                })
                .catch(function (reason) {
                    window.console.log(reason);
                })
                .finally(function () {
                    window.obMindbox.removeLoadingFromBtn(event.target);
                });
        }
    },
    /**
     * Функция добавляет обработчик события переключения флажка "Согласен на участие в программе лояльности".
     */
    initSwitchLoyaltyCheckbox: function () {
        "use strict";

        const loyaltyCheckboxes = document.querySelectorAll(".js-inp_loyalty");
        Array.prototype.forEach.call(loyaltyCheckboxes, function (loyaltyCheckbox) {
            loyaltyCheckbox.addEventListener("change", Register.changeLoyaltyCheckboxHandler);
        });
    },
    /**
     * Функция обрабатывает переключение флага "Согласен на участие в программе лояльности":
     * если флаг установлен, показываем всплывающее окно с подтверждением телефона;
     * если флаг сброшен, устанавливаем пользователю большой срок,
     * когда ему не нужно напоминать про участие в программе лояльности и сбрасываем флаг "Верифицирован в MindBox"
     */
    changeLoyaltyCheckboxHandler: function (event) {
        "use strict";

        if (!!event) {
            if (event.target.checked) {
                // Пользователь активировал галочку "Согласен на участие в программе лояльности"
                window.obMindbox.personal.getMindboxUserId()
                    .then(function (mindboxUserId) {
                        if (mindboxUserId) {
                            Register.checkLoyaltyProgram();
                        }
                    })
                    .catch(function (reason) {
                        window.console.log(reason);
                    });
            } else if (window.isAuthUser) {
                // Авторизованный пользователь снял галочку "Согласен на участие в программе лояльности"
                Register.logOutLoyaltyProgram();
            }
        }
    },
    /**
     * Функция обрабатывает выход пользователя из программы лояльности
     */
    logOutLoyaltyProgram: function () {
        "use strict";

        const userId = window.BX.message("USER_ID");

        if (userId) {
            // Создаем экземпляр класса XMLHttpRequest
            let request = new XMLHttpRequest();

            let formData = new FormData();

            formData.append("user_id", userId);

            request.open("POST", "/ajax/user/log_out_mindbox_lp.php", true);

            request.responseType = "json";

            request.send(formData);

            request.onload = function () {
                if (request.readyState === 4 && request.status === 200) {
                    const jsonResponse = request.response;
                    if (!!jsonResponse && jsonResponse.success) {
                        // Пользователя отключили от программы лояльности
                    } else {
                        window.console.log("Запрос выполнился, но не получено полезной нагрузки.");
                    }
                } else {
                    // Запрос не выполнился
                    window.console.log("Запрос не выполнился. " + request.status + ": " + request.statusText);
                }
            }
        } else {
            alert("Ошибка: не определён пользователь");
        }
    },
    /**
     * Обработчик изменения телефона
     *
     * @param {Object} event
     */
    changePhoneHandler: function (event) {
        "use strict";

        if (!!event) {
            // Предлагаем пользователю подтвердить новый телефон для участия программе лояльности
            Register.checkLoyaltyProgram(event.target.value);
        }
    },
    /**
     * Функция устанавливает положение переключателя "Согласен на участие в программе лояльности":
     *
     * @param {Boolean} isChecked Положение флажка, которое требуется установить
     */
    setLoyaltyCheckbox: function (isChecked) {
        "use strict";

        const loyaltyCheckboxes = document.querySelectorAll(".js-inp_loyalty");
        Array.prototype.forEach.call(loyaltyCheckboxes, function (loyaltyCheckbox) {
            loyaltyCheckbox.checked = isChecked;
        });
    },
    /**
     * Метод возвращает объект со всеми данными программы лояльности
     * из данных data атрибутов данных пользователя
     */
    getLoyaltyProgramData: function () {
        "use strict";

        let result = {};
        const lpDataElement = document.getElementsByClassName("js-user-lp-data")[0];
        if (lpDataElement) {
            result = {
                "isNeedMindboxUserCheck": lpDataElement.dataset.isNeedMindboxUserCheck,
                "isNeedMindboxLpCheck": lpDataElement.dataset.isNeedMindboxLpCheck
            }
        }

        return result;
    },
    /**
     * Функция отправляет данные пользователя для регистрации в Mindbox
     */
    sendRegister: function () {
        "use strict";

        return new Promise(function (resolve, reject) {
            const userId = window.BX.message("USER_ID");

            if (userId) {
                // Создаем экземпляр класса XMLHttpRequest
                let request = new XMLHttpRequest();

                let formData = new FormData();

                formData.append("user_id", userId);

                request.open("POST", "/ajax/user/register_user_mindbox.php", true);

                request.responseType = "json";

                request.send(formData);

                request.onload = function () {
                    if (request.readyState === 4 && request.status === 200) {
                        const jsonResponse = request.response;
                        if (!!jsonResponse && jsonResponse.mindboxUserId) {
                            window.obMindbox.personal.mindboxUserId = jsonResponse.mindboxUserId;
                            window.obMindbox.personal.setMindboxUserId(jsonResponse.mindboxUserId);
                            resolve(window.obMindbox.personal.mindboxUserId);
                        } else {
                            reject(new Error("Запрос выполнился, но не получено полезной нагрузки."));
                        }
                    } else {
                        // Запрос не выполнился
                        reject(new Error("Запрос не выполнился. " + request.status + ": " + request.statusText));
                    }
                };
            } else {
                reject(new Error( "Пользователь не определён"));
            }
        });
    },
    /**
     * Метод проверяет, требуется ли пользователю предложить зарегистрироваться в программе лояльности.
     * Требуется предложить регистрацию если:
     * 1) пользователь ещё не зарегистрирован в программе лояльности
     * 2) у пользователя уже прошёл период, когда ему давали передышку
     * и не беспокоили предложением зарегистрироваться в программе лояльности
     *
     * @param {string|null} newPhone
     */
    checkLoyaltyProgram: function (newPhone) {
        "use strict";

        // Фиксируем время, когда окно отобразили
        Register.showFormLastDate = new Date();

        let requestData = {
            CLOSED: "Y",
            isOrderPage: this.isOrderPage ? "Y" : "N"
        };
        if (!!newPhone) {
            requestData.USER_PHONE = newPhone;
        }
        sendRequest({
            url: "/ajax/loyalty/register.php",
            method: "GET",
            data: requestData,
            success: function (res) {
                if (res.length > 0) {
                    /**
                     * @todo Переделать всплывающее окно на стандартное для шаблона сайта,
                     *       или разобраться, почему ломается прокрутка страницы после закрытия всплывающего окна.
                     */
                    /*
                    window.modal.showMessages(
                        "notice",
                        "Программа лояльности",
                        ["!!!"],
                        [],
                        [],
                        res
                    );
                    */
                    replaceModal(res, Register.modalName, function () {
                        sendRequest({
                            url: "/ajax/loyalty/register.php",
                            method: "POST",
                            data: {CLOSED: "Y"}
                        })
                    }, function () {
                        window.masks.initPhones();
                        Register.initResendSms();

                        // Отобразим все сообщения (по-умолчанию они скрыты)
                        let domModalForm = document.getElementById(Register.modalName)
                        let messagesWrappers = domModalForm.querySelectorAll(".messages");
                        if (messagesWrappers.length) {
                            let firstMessagesWrapper = messagesWrappers[0];

                            Register.displayMessages(firstMessagesWrapper);
                        }

                        document.getElementById(Register.modalName).addEventListener("submit", event => {
                            event.preventDefault();
                            const oForm = event.target;
                            let method = oForm.getAttribute("method");
                            let url = oForm.getAttribute("action");
                            let data = {};
                            oForm.querySelectorAll("input").forEach(elm => {
                                data[elm.name] = elm.value;
                            });
                            oForm.querySelector("button[type=\"submit\"]").disabled = true;

                            sendRequest({
                                url: url,
                                data: data,
                                method: method,
                                success: function (res) {
                                    if (res.length > 0) {
                                        replaceModal(res, Register.modalName);
                                        window.masks.initPhones();
                                        Register.initResendSms();

                                        // Отобразим все сообщения (по-умолчанию они скрыты)
                                        let domModalForm = document.getElementById(Register.modalName)
                                        let messagesWrappers = domModalForm.querySelectorAll(".messages");
                                        if (messagesWrappers.length) {
                                            let firstMessagesWrapper = messagesWrappers[0];

                                            Register.displayMessages(firstMessagesWrapper);
                                        }

                                        // Костыль (было бы лучше, если бы с сервера приходила не разметка, а JSON):
                                        // если пришли ошибки в форме, — снимем галочки
                                        // "Согласен на участие в программе лояльности"
                                        let errorsWrappers = domModalForm.querySelectorAll(".modal-form__item.error");
                                        if (errorsWrappers.length) {
                                            Register.setLoyaltyCheckbox(false);
                                        }

                                        if (document.querySelector(".js-filling")) {
                                            jsAjaxButtonHandler(".js-filling", "data-target", "data-metod", "data-dist", function (res, item) {
                                                res = JSON.parse(res);
                                                if (res.message !== "undefined") {
                                                    document.querySelector("label[for='" + item.getAttribute("data-target") + "']").textContent = res.message;
                                                }
                                            });
                                        }
                                    } else {
                                        oForm.querySelector("button[type=\"submit\"]").disabled = false;
                                    }
                                }
                            });
                        });
                    });

                    if (document.querySelector(".js-filling")) {
                        jsAjaxButtonHandler(".js-filling", "data-target", "data-metod", "data-dist", function (res, item) {
                            res = JSON.parse(res);
                            if (res.message !== "undefined") {
                                document.querySelector("label[for='" + item.getAttribute("data-target") + "']").textContent = res.message;
                            }
                        });
                    }
                }
            }
        });
    },
    /**
     * Метод выполняет запрос на сервер для переотправки СМС в Mindbox
     *
     * @param {Number} mindboxUserId Идентификатор пользователя в Mindbox
     * @param {String} phone         Телефон, куда нужно переотправить СМС
     *
     * @returns {Promise<unknown>}
     */
    resendSms: function (mindboxUserId, phone) {
        "use strict";

        return new Promise(function (resolve, reject) {
            if (mindboxUserId && phone) {
                // Создаем экземпляр класса XMLHttpRequest
                let request = new XMLHttpRequest();

                let formData = new FormData();

                formData.append("mindbox_user_id", mindboxUserId);
                formData.append("phone", phone);

                request.open(
                    "POST",
                    "/ajax/user/mindbox_resend_sms.php",
                    true
                );

                request.responseType = "json";

                request.send(formData);

                request.onload = function () {
                    if (request.readyState === 4 && request.status === 200) {
                        const jsonResponse = request.response;
                        if (!!jsonResponse) {
                            resolve(jsonResponse);
                        } else {
                            reject(new Error("Запрос выполнился, но не получено полезной нагрузки."));
                        }
                    } else {
                        // Запрос не выполнился
                        reject(new Error("Запрос не выполнился. " + request.status + ": " + request.statusText));
                    }
                };
            } else {
                reject(new Error("Пользователь или телефон не определён"));
            }
        });
    },
    showMessageModalForm: function (domModalForm, arNoticeMessages, arSuccessMessages, arErrors) {
        "use strict";

        let messagesWrappers = domModalForm.querySelectorAll(".messages");
        if (messagesWrappers.length) {
            let firstMessagesWrapper = messagesWrappers[0];
            window.obMindbox.clearElem(firstMessagesWrapper);
            let messageBlock;
            let isNoticeMessages = false;
            let isSuccessMessages = false;
            let isErrors = false;
            if (!!arNoticeMessages) {
                arNoticeMessages.forEach(function (message) {
                    messageBlock = window.modal.getMessageItemBlock("notice", message);
                    if (messageBlock.length) {
                        isNoticeMessages = true;
                        firstMessagesWrapper.insertAdjacentHTML("beforeend", messageBlock);
                    }
                });
            }
            if (!!arSuccessMessages) {
                arSuccessMessages.forEach(function (message) {
                    messageBlock = window.modal.getMessageItemBlock("success", message);
                    if (messageBlock.length) {
                        isSuccessMessages = true;
                        firstMessagesWrapper.insertAdjacentHTML("beforeend", messageBlock);
                    }
                });
            }
            if (!!arErrors) {
                arErrors.forEach(function (message) {
                    messageBlock = window.modal.getMessageItemBlock("error", message);
                    if (messageBlock.length) {
                        isErrors = true;
                        firstMessagesWrapper.insertAdjacentHTML("beforeend", messageBlock);
                    }
                });
            }

            if (isNoticeMessages || isSuccessMessages || isErrors) {
                // Отобразим все сообщения (по-умолчанию они скрыты)
                Register.displayMessages(firstMessagesWrapper);
            }
        }
    },
    /**
     * Функция отображает дочерние элементы, которые находятся в разметке в скрытом состоянии
     *
     * @param elemWrapper
     */
    displayMessages: function (elemWrapper) {
        "use strict";

        let elementChildren = elemWrapper.children;
        for (let i = 0, child; child = elementChildren[i]; i++) {
            child.style.display = "block";
        }
    }
}

export {
    Register
}
